<script setup lang="ts">
import type { DataTableCellProps } from '@common';
import type { ParcelHeightmapItem } from '../models';
import { computed, toRefs } from 'vue';
import { useColorMapStore, findColorByValue } from '../../colormap';
import { LayerKind } from '@shared';

const props = defineProps<DataTableCellProps<any, ParcelHeightmapItem>>();
const { item } = toRefs(props);

const colorMapStore = useColorMapStore();

const color = computed(() => {
  const heightMapAssignedAreaLayer = item.value.data.heightmap.layers.find(
    (layer) => layer.kind === LayerKind.heightMapAssignedArea
  );

  if (!heightMapAssignedAreaLayer || !heightMapAssignedAreaLayer.colorMap) {
    return;
  }

  const colorMap = colorMapStore.findColorMap(heightMapAssignedAreaLayer.colorMap);
  return findColorByValue(item.value.data.coverage, colorMap ? colorMap.breaks : [], colorMap ? colorMap.colors : []);
});
</script>

<template>
  <div v-if="color">
    <v-chip :color="color">{{ item.data.coverage }} %</v-chip>
  </div>
</template>
